import * as ol from 'openlayers'
import { DataTheme } from 'src/Enums'
import { GeoLayer, AbstractLayer, AbstractLayerOptions } from './Layer'
import { layerCopyrights, LayerDescription, LayerGroup, LayerParamsObject, LayerType } from './LayerRegistry'
import { DataforsyningenToken } from '../dataforsyningen/Dataforsyningen'
import { ContextTag } from '../wiki/Wiki'

/**
 * Map layer class for the Orto background layer.
 */
class OrtoBackgroundLayer extends AbstractLayer implements GeoLayer {
  static readonly defaultParams: LayerParamsObject = {
  }

  constructor (options: any) {
    const defaultOptions: AbstractLayerOptions = {
      layerType: LayerType.ORTO_BACKGROUND,
      enabled: true,
      zIndex: 0
    }
    super({ ...defaultOptions, ...options })

    this.olLayer = new ol.layer.Image({
      source: new ol.source.ImageWMS({
        url: 'https://api.dataforsyningen.dk/orto_foraar_DAF',
        params: {
          token: DataforsyningenToken,
          layers: ['orto_foraar'],
          transparent: 'FALSE'
        },
        projection: new ol.proj.Projection({
          code: 'EPSG:25832'
        }),
      })
    })
  }

  static describe (): LayerDescription {
    return {
      type: LayerType.ORTO_BACKGROUND,
      name: 'map.layer.orto',
      group: LayerGroup.BACKGROUND_MAPS,
      contextTags: [
        ContextTag.ORTO
      ],
      themes: Object.values(DataTheme),
      capabilitiesUrl: '',
      legendEnabled: false,
      opacityEnabled: false,
      layerCopyright: layerCopyrights.Geodatastyrelsen
    }
  }
}

export default OrtoBackgroundLayer
